import { render, staticRenderFns } from "./ProjectWrite.vue?vue&type=template&id=8a06f182&scoped=true&"
import script from "./ProjectWrite.vue?vue&type=script&lang=js&"
export * from "./ProjectWrite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a06f182",
  null
  
)

export default component.exports